import React from 'react';

const BigModal = ({ children }) => {
    return (
        <div className="big-modal">
            {children}
        </div>
    )
}

export default BigModal;
